// extracted by extract-css-chunks-webpack-plugin
module.exports = {"no-appearance-button":"_185TDH"};